import AntIcon from "@/components/icons/AntIcon";
import { useToken } from "@/utils/hooksUtils";
import { Flex, Popover, Tag } from "antd";
import type { ReactNode } from "react";

type Props = {
  label: string;
  value: ReactNode;
  error?: boolean;
  onClick?: () => void;
  children?: ReactNode;
};

export const CalcValueTag = ({ label, value, error, onClick, children }: Props) => {
  const { token } = useToken();

  const tag = (
    <Tag
      variant="outlined"
      onClick={onClick}
      style={{
        margin: 0,
        padding: "4px 10px",
        fontSize: 14,
        lineHeight: "22px",
        cursor: "pointer",
        background: token.colorBgContainer,
        borderColor: error ? token.colorError : token.colorBorder,
      }}
    >
      <span style={{ color: token.colorTextSecondary }}>{label}: </span>
      <strong>{value}</strong>
      <AntIcon type="down" style={{ marginLeft: 6, fontSize: 10 }} />
    </Tag>
  );

  if (!children) {
    return tag;
  }

  return (
    <Popover
      trigger="click"
      placement="bottomLeft"
      content={
        <Flex vertical gap="small" style={{ minWidth: 220 }}>
          {children}
        </Flex>
      }
    >
      {tag}
    </Popover>
  );
};
